// import {fabric} from 'fabric';
import * as THREE from 'three';


export async function createTexture(width, height, text = '') {
    function createCanvas(dashed, text) {
        const canvas = document.createElement('canvas');
        canvas.width = width * 3000;
        canvas.height = height * 3000;
        const ctx = canvas.getContext('2d');

        const strokeWidth = dashed ? 1.5 : 4;

        // Draw border
        ctx.strokeStyle = 'white';
        ctx.lineWidth = strokeWidth;
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Draw text if provided
        if (text) {
            let fontSize = 60; // Starting font size
            ctx.font = `${fontSize}px DINPro Condensed`;
            ctx.fillStyle = 'black';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(text, canvas.width / 2, canvas.height / 2);

            // Decrease the font size until the text fits
            while (ctx.measureText(text).width > canvas.width - 40 && fontSize > 1) {
                fontSize -= 1;
                ctx.font = `${fontSize}px DINPro Condensed`;
            }

            // Remove the text and draw it again with the correct font size
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.font = `${fontSize}px DINPro Condensed`;
            ctx.fillStyle = 'black';
            ctx.fillText(text, canvas.width / 2, canvas.height / 2);
            
        }

        return canvas;

    }
    
    const solidBorderCanvas = await createCanvas(false, text);
    const solidBorderCanvasText = await createCanvas(false, text);
    const dashedBorderCanvas = await createCanvas(true, text);

    // // download the canvas as an image
    // const download = document.createElement('a');
    // download.href = solidBorderCanvas.toDataURL('image/png');
    // download.download = 'section.png';
    // download.click();
    
    
    const hover = new THREE.CanvasTexture(solidBorderCanvas);
    const hoverText = new THREE.CanvasTexture(solidBorderCanvasText);
    const normal = new THREE.CanvasTexture(dashedBorderCanvas);
    
    
    return {normal: normal, hover: hover, hoverText: hoverText};
}
